import React, { useEffect, useState } from "react";
const API_URL = process.env.REACT_APP_API_URL;
const UserList = () => {
  const [users, setUsers] = useState([]);
  const [editUser, setEditUser] = useState(null);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  const fetchUsers = async () => {
    try {
      const res = await fetch(`${API_URL}/api/users`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const data = await res.json();
      setUsers(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const confirmDelete = async () => {
    await fetch(`${API_URL}/api/users/${deleteUserId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    setDeleteUserId(null);
    fetchUsers();
    setSuccessMessage("User deleted successfully ✅");
  };

  const handleUpdate = async () => {
    await fetch(`https://localhost:3000/api/users/${editUser.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        name: editUser.name,
        email: editUser.email,
        mobile_number: editUser.mobile_number,
      }),
    });

    setEditUser(null);
    fetchUsers();
    setSuccessMessage("User updated successfully ✅");
  };

  return (
    <div className="pt-6 pb-8 max-w-5xl mx-auto">

      {/* HEADER */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-2xl p-6 shadow mb-6">
        <h2 className="text-2xl font-semibold">User List</h2>
        <p className="text-sm opacity-90 mt-1">Manage users and their details</p>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-2xl shadow p-8">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">

            <thead className="bg-blue-600 text-white">
              <tr>
                <th className="px-6 py-4 text-left font-medium">#</th>
                <th className="px-6 py-4 text-left font-medium">Name</th>
                <th className="px-6 py-4 text-left font-medium">Username</th>
                <th className="px-6 py-4 text-left font-medium">Email</th>
                <th className="px-6 py-4 text-left font-medium">Mobile</th>
                <th className="px-6 py-4 text-center font-medium">Actions</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100">
              {users.map((u, index) => (
                <tr key={u.id} className="hover:bg-blue-50/60 transition">

                  <td className="px-6 py-4 text-gray-600">{index + 1}</td>
                  <td className="px-6 py-4 font-medium text-gray-800">{u.name}</td>
                  <td className="px-6 py-4 text-gray-700">{u.username}</td>
                  <td className="px-6 py-4 text-gray-700">{u.email || "-"}</td>
                  <td className="px-6 py-4 text-gray-700">{u.mobile_number || "-"}</td>

                  <td className="px-6 py-4">
                    <div className="flex justify-center gap-3">
                      <button
                        onClick={() => setEditUser(u)}
                        className="px-6 py-2 text-xs font-medium rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition min-w-[78px]"
                      >
                        Edit
                      </button>

                      <button
                        onClick={() => setDeleteUserId(u.id)}
                        className="px-6 py-2 text-xs font-medium rounded-xl bg-red-600 text-white hover:bg-red-700 transition min-w-[78px]"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* EDIT MODAL */}
      {editUser && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 space-y-4">
            <h2 className="text-xl font-semibold">Edit User</h2>

            <input
              value={editUser.name}
              onChange={(e) => setEditUser({ ...editUser, name: e.target.value })}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500"
            />

            <input
              value={editUser.mobile_number || ""}
              onChange={(e) => setEditUser({ ...editUser, mobile_number: e.target.value })}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500"
            />

            <input
              value={editUser.email || ""}
              onChange={(e) => setEditUser({ ...editUser, email: e.target.value })}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500"
            />

            <div className="flex justify-end gap-3 pt-4">
              <button
                onClick={() => setEditUser(null)}
                className="px-6 py-2.5 bg-gray-200 rounded-xl hover:bg-gray-300 transition font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdate}
                className="px-6 py-2.5 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition font-medium"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DELETE MODAL */}
      {deleteUserId && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6 space-y-4">
            <h2 className="text-lg font-semibold text-gray-800">Delete User</h2>
            <p className="text-sm text-gray-600">
              Are you sure you want to delete this user? This action cannot be undone.
            </p>

            <div className="flex justify-end gap-3 pt-4">
              <button
                onClick={() => setDeleteUserId(null)}
                className="px-6 py-2.5 bg-gray-200 rounded-xl hover:bg-gray-300 transition font-medium"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-6 py-2.5 bg-red-600 text-white rounded-xl hover:bg-red-700 transition font-medium"
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SUCCESS MESSAGE */}
      {successMessage && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 text-center">
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-xl font-semibold mb-2">Success</h2>
            <p className="text-gray-600 mb-6">{successMessage}</p>
            <button
              onClick={() => setSuccessMessage("")}
              className="px-8 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition font-medium"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserList;